<template>
  <div class="input-body-code">
    <div class="int-box">
      <div class="show-pwd-box" :class="{'err-input': error}" id="Password">
        <input type="text" :value="k1" maxlength="1" readonly />
        <input type="text" :value="k2" maxlength="1" readonly />
        <input type="text" :value="k3" maxlength="1" readonly />
        <input type="text" :value="k4" maxlength="1" readonly />
        <input type="text" :value="k5" maxlength="1" readonly />
        <input type="text" :value="k6" maxlength="1" readonly />
      </div>
      <div class="pwd-box">
        <el-input
          class="el-pwd-int"
          ref="inputref"
          type="text"
          maxlength="6"
          v-model.trim="otpCode"
          unselectable="on"
          :onkeyup="otpCode = otpCode.replace(/\D/g,'')"
          @input="intChange"
        />
      </div>
    </div>
    <div class="verifyimg-box">
      <img
        class="verifyimg"
        v-if="isShow"
        @click="toggleMask"
        src="@/assets/pc/Icon - Unmask@3x.png"
      />
      <img
        class="verifyimg"
        v-if="!isShow"
        @click="toggleMask"
        src="@/assets/pc/mask-outline.svg"
      />
    </div>
  </div>
</template>

<script>
let timeId = null;
export default {
  name: "Code",
  props: {
    error: {
        type: String,
        default: ''
    },
  },
  data() {
    return {
      otpCode: "",
      otCList: [],
      isShow: false,
      hideIcon: '●',
      k1: '',
      k2: '',
      k3: '',
      k4: '',
      k5: '',
      k6: '',
      lastVal: [],
    };
  },
  computed: {
  },
  watch: {
    otpCode: {
      handler: function (val) {
        this.otCList = val ? val.split("") : [];
        this.$emit("otpCode", val);
      },
      deep: true,
    },
  },
  methods: {
    toggleMask() {
      this.isShow = !this.isShow;
      this.getVal (this.otCList, false, undefined)
    },
    getVal (otCList, isDelete, addIndex) {
      this.k1 = '';
      this.k2 = '';
      this.k3 = '';
      this.k4 = '';
      this.k5 = '';
      this.k6 = '';
      otCList.map((item, index)=>{
        const { isShow } = this;
        const val = item || "";
        this[`k${index+1}`] = val
        if (!isShow){
          if(!isDelete){
            this[`k${index+1}`] = this.hideIcon
            if(addIndex !== undefined){
              this[`k${addIndex+1}`] = otCList[Number(addIndex)]
              clearTimeout(timeId)
              timeId = setTimeout(() => {
                if(this[`k${addIndex+1}`]){
                  this[`k${addIndex+1}`] = this.isShow ? otCList[Number(addIndex)] : this.hideIcon
                }
              }, 2000);
            }
          }else{
            this[`k${index+1}`] = this.hideIcon
          }
        }
      })
    },
    intChange(value) {
      let isDelete = false
      let addIndex = undefined
      this.$emit("clearError");
      const otCList = value ? value.split("") : []
      if(this.lastVal.length > otCList.length){
        isDelete = true;
      }else{
        for(let i = 0; i < otCList.length; i++){
          if(otCList[i] != this.lastVal[i]){
            addIndex = i
            break;
          }
        }
      }
      this.lastVal = otCList
      if (this.otpCode.length > 6) {
        this.otpCode = this.otpCode.slice(0, 6);
      }
      this.getVal(otCList, isDelete, addIndex);
    },
    clearIpt() {
      this.otpCode = ''
      this.$emit("otpCode", '');
      this.lastVal = []
      this.k1 = '';
      this.k2 = '';
      this.k3 = '';
      this.k4 = '';
      this.k5 = '';
      this.k6 = '';
    }
  },
  mounted() {
    // 等待dom渲染完成，在执行focus,否则无法获取到焦点
    // this.$nextTick(() => {
    //   this.$refs.inputref.focus();
    // });
  },
};
</script>

<style scoped lang="scss">
.input-body-code {
  margin-top: 24px;
  // padding-right: 28px;
  padding: 0 55px 0 23px;
  min-height: 30px;
  position: relative;
  box-sizing: border-box;
  .int-box {
    position: relative;
    height: 48px;
    .show-pwd-box {
      height: 48px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      input {
        display: block;
        // flex: 1;
        // width: 95%;
        width: 40px;
        height: 100%;
        border: 1px solid #99c1e7;
        border-radius: 8px;
        // font-size: 20px;
        font: normal normal bold 20px/32px Nunito;
        box-sizing: border-box;
        // margin-right: 2%;
        text-align: center;
        color: #2E2E2E;
        overflow: hidden;
        box-shadow: none;
        background: transparent;
      }
    }
    .err-input{
        input{
            border-color: #FF3700;
        }
    }
    .pwd-box {
      position: absolute;
      z-index: 3;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      width: 100%;
      height: 48px;

      ::v-deep {
        .el-pwd-int {
          display: block;
          height: 48px;
          input {
            display: block;
            background-color: transparent;
            color: transparent;
            outline: none;
            width: 100%;
            height: 100%;
            z-index: 1;
            box-sizing: border-box;
            border: none !important;
            letter-spacing: 35px;
            padding: 0;
            // caret-color: $title-color; // 光标颜色
            caret-color: transparent;
          }
          .el-input__inner:focus {
            box-shadow: none;
          }
        }
      }
    }
  }
  .verifyimg-box {
    position: absolute;
    z-index: 21;
    top: 50%;
    margin-top: -12px;
    right: 23px;
    .verifyimg {
      width: 24px;
      height: 24px;
    }
  }
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    appearance: none;
    margin: 0;
  }
}
</style>